import { apiUrl } from '../config/api'

function getAuthHeader() {
    const secret = localStorage.getItem('x-auth-secret')
    return secret ? { 'x-auth-secret': secret } : {}
}

export async function listFinancialRecords() {
    const resp = await fetch(apiUrl('/api/admin/financial-records'), {
        headers: { ...getAuthHeader(), 'Accept': 'application/json' }
    })
    if (!resp.ok) throw new Error(await resp.text() || 'Failed to fetch financial records')
    return resp.json()
}

export async function createFinancialRecord(record) {
    const resp = await fetch(apiUrl('/api/admin/financial-records'), {
        method: 'POST',
        headers: { ...getAuthHeader(), 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(record)
    })
    if (!resp.ok) throw new Error(await resp.text() || 'Failed to create financial record')
    return resp.json()
}

export async function updateFinancialRecord(id, record) {
    const resp = await fetch(apiUrl(`/api/admin/financial-records/${id}`), {
        method: 'PUT',
        headers: { ...getAuthHeader(), 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(record)
    })
    if (!resp.ok) throw new Error(await resp.text() || 'Failed to update financial record')
    return resp.json()
}

export async function deleteFinancialRecord(id) {
    const resp = await fetch(apiUrl(`/api/admin/financial-records/${id}`), {
        method: 'DELETE',
        headers: { ...getAuthHeader() }
    })
    if (!resp.ok) throw new Error(await resp.text() || 'Failed to delete financial record')
}
